import React, { useEffect, useState } from 'react'
import { GpButton, Icon } from '../../components/gp'
import { formatAmounts } from './../../utilities/generalUtils'


const FundsSelectRecurring = (props) => {
    const [amount, setAmount] = useState(null)
    const [showAmountError, setShowAmountError] = useState(false)

    useEffect(() => {
        if (props.funds) {
            setAmount(props.funds)
        }
    }, [])

    useEffect(() => {
        if (amount) {
            setShowAmountError(false)
        }
    }, [amount])

    const handleContinue = () => {
        if (!amount) {
            setShowAmountError(true)
            return
        }
        props.fundsSelected(amount)
    }

    return (
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
            {/* Info card */}
            <div
                style={{
                    display: 'flex',
                    gap: 14,
                    background: 'var(--gp-lime-soft)',
                    borderRadius: 'var(--gp-r-md)',
                    padding: '14px 16px',
                    marginBottom: 24,
                    alignItems: 'flex-start',
                }}
            >
                <div
                    style={{
                        width: 32,
                        height: 32,
                        borderRadius: 10,
                        background: 'var(--gp-card)',
                        color: 'var(--gp-brand)',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                    }}
                >
                    <Icon name="shield" size={16} />
                </div>
                <div style={{ font: 'var(--gp-body)', color: 'var(--gp-ink)', lineHeight: 1.5 }}>
                    This property charges a fixed <strong style={{ fontWeight: 500 }}>monthly access fee</strong> for
                    EV charging in your parking space. Your card won't be charged until your property manager
                    approves you — the fee is then collected on the{' '}
                    <strong style={{ fontWeight: 500 }}>1st of each month</strong>. You can upgrade your plan at any time.
                </div>
            </div>

            {/* Fee option buttons */}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                    gap: 12,
                    marginBottom: 14,
                }}
            >
                {props.recurringFees?.map((fee) => {
                    const active = amount === fee.price
                    return (
                        <button
                            key={fee.name}
                            type="button"
                            onClick={() => setAmount(fee.price)}
                            style={{
                                width: 160,
                                height: 96,
                                padding: '0 16px',
                                borderRadius: 'var(--gp-r-md)',
                                border: '1.5px solid ' + (active ? 'var(--gp-brand)' : 'var(--gp-hairline)'),
                                background: active ? 'var(--gp-brand)' : 'var(--gp-card)',
                                color: active ? '#FFFFFF' : 'var(--gp-ink)',
                                cursor: 'pointer',
                                transition: 'all 0.12s ease',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 6,
                            }}
                        >
                            <span
                                style={{
                                    font: '500 11px/1 var(--gp-font)',
                                    letterSpacing: 0.8,
                                    textTransform: 'uppercase',
                                    color: active ? 'var(--gp-lime)' : 'var(--gp-ink-mute)',
                                }}
                            >
                                Access Fee
                            </span>
                            <span style={{ font: '500 32px/1 var(--gp-font)', letterSpacing: -0.5 }}>
                                {formatAmounts(fee.price, false)}
                            </span>
                            <span
                                style={{
                                    font: '400 11px/1 var(--gp-font)',
                                    color: active ? 'rgba(255,255,255,0.7)' : 'var(--gp-ink-mute)',
                                }}
                            >
                                per month
                            </span>
                        </button>
                    )
                })}
            </div>

            {showAmountError && (
                <div
                    style={{
                        font: 'var(--gp-caption)',
                        color: 'var(--gp-danger)',
                        textAlign: 'center',
                        marginBottom: 12,
                    }}
                >
                    Please select a plan to continue.
                </div>
            )}

            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <GpButton
                    variant="primary"
                    onClick={handleContinue}
                    style={{ minWidth: 200 }}
                >
                    Continue
                </GpButton>
            </div>
        </div>
    )
}

export default FundsSelectRecurring
